import { LandingPage } from "./views/landing";

function App() {


  return (
    <>
      <LandingPage />
    </>
  );
}

export default App;
